<template>
<!-- <vs-card class="cardx"> -->
  <div>
    <vs-row>
      {{$data._title}}
      <vs-popup class="pop_ps" :title="'Modulo '+$data.title" :active.sync="popupActivo">
        <vs-col>
            <Info :message="$data.message"/>
        </vs-col>
      </vs-popup>
      <vs-row class="ps_vs-row">
        <vs-col vs-lg="2" vs-xs="12">
            <vs-card>
              <vs-button class="btn_info" color="#B87333" type="border" icon="help" @click="title='Total', message=msgA, popupActivo=true">
              </vs-button>
              <h4 class="mb-1">{{stateA.state}}</h4>
              <span>Total</span>
              <vs-progress :percent="$data.stateA.percentage" color="primary"></vs-progress>
              <div class="div_btn_filter">
              <vs-button class="btn_filter" color="#006400" type="border" @click="type=0, activeTipe()">Filtrar
              </vs-button>
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="2" vs-xs="12">
            <vs-card>
              <vs-button class="btn_info" color="#B87333" type="border" icon="help" @click="title='Activos', message=msgB, popupActivo=true">
              </vs-button>
              <h4 class="mb-1">{{stateB.state}}</h4>
              <span>Activos</span>
              <vs-progress :percent="$data.stateB.percentage" color="rgb(23, 83, 65)"></vs-progress>
              <div class="div_btn_filter">
              <vs-button class="btn_filter" color="#006400" type="border" @click="type=1, activeTipe()">Filtrar
              </vs-button>
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="2" vs-xs="12">
            <vs-card>
              <vs-button class="btn_info" color="#B87333" type="border" icon="help" @click="title='Inactivos', message=msgC, popupActivo=true">
              </vs-button>
              <h4 class="mb-1">{{stateC.state}}</h4>
              <span>Inactivos</span>
              <vs-progress :percent="$data.stateC.percentage" color="#ff4757"></vs-progress>
              <div class="div_btn_filter">
              <vs-button class="btn_filter" color="#006400" type="border" @click="type=2, activeTipe()">Filtrar
              </vs-button>
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="2" vs-xs="12">
            <vs-card>
              <vs-button class="btn_info" color="#B87333" type="border" icon="help" @click="title='Alertas Cámaras', message=msgE, popupActivo=true">
              </vs-button>
              <h4 class="mb-1">{{stateE.state}}</h4>
              <span>Alertas Cámaras</span>
              <vs-progress :percent="$data.stateE.percentage" color="#ffeb3b"></vs-progress>
              <div class="div_btn_filter">
              <vs-button class="btn_filter" color="#006400" type="border" @click="type=4, activeTipe()">Filtrar
              </vs-button>
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="2" vs-xs="12">
            <vs-card>
              <vs-button class="btn_info" color="#B87333" type="border" icon="help" @click="title='Alertas Sistema', message=msgF, popupActivo=true">
              </vs-button>
              <h4 class="mb-1">{{stateF.state}}</h4>
              <span>Alertas Sistema</span>
              <vs-progress :percent="$data.stateF.percentage" color="#ffab6f"></vs-progress>
              <div class="div_btn_filter">
              <vs-button class="btn_filter" color="#006400" type="border" @click="showLastxAlertModal = true;">Mostrar
              </vs-button>
              <vs-button class="btn_filter" color="#006400" type="border" @click="type=5, activeTipe()">Filtrar
              </vs-button>
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="2" vs-xs="12"></vs-col>
        <!-- <vs-col vs-lg="2" vs-xs="12">
            <vs-card>
              <vs-button class="btn_info" color="#B87333" type="border" icon="help" @click="title='No Inicializados', message=msgD, popupActivo=true">
              </vs-button>
              <h4 class="mb-1">{{stateD.state}}</h4>
              <span>Pre Configurados</span>
              <vs-progress :percent="$data.stateD.percentage" color="#6c757d"></vs-progress>
              <div class="div_btn_filter">
              <vs-button class="btn_filter" color="#006400" type="border" @click="type=3, activeTipe()">Filtrar
              </vs-button>
              </div>
            </vs-card>
        </vs-col> -->
      </vs-row>
      <vs-row>
        <vs-col type="flex" vs-justify="center" vs-align="center">
            <vs-card class="cardx">
              <div slot="header">
                <h4>
                  Estado del equipo
                </h4>
              </div>
              <div>
                <Grid :newInfoBox="$data.newInfoBox" :type="$data.type"/>
              </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-row>
    <div v-if="newInfoBox == ''" class="ps_div_alert">
      <vs-alert class="ps_alert_box_list" title="Information" color="rgb(231, 154, 23)">
              No hay datos para mostrar.
      </vs-alert>
    </div>
    <div>
      <LastxAlertModal :show="showLastxAlertModal" @close="showLastxAlertModal = false">
        <template #body>
          <!-- <div slot="header">
            <h4>
              Alertas
            </h4>
          </div> -->
          <div>
            <LastxAlerts/>
          </div>
        </template>
      </LastxAlertModal>
    </div>
  </div>
<!-- </vs-card> -->
</template>

<script>
import axios from 'axios'
import Grid from './Grid.vue'
import Info from '../utils/Info.vue'
import LastxAlertModal from "../utils/ModalLastxAlerts.vue";
import LastxAlerts from "./LastxAlerts.vue"

export default {
  name: 'state',
  components: {
    Grid,
    Info,
    LastxAlertModal,
    LastxAlerts,
},
  data(){
    return {
      newInfoBox: [],
      type: 1,
      stateA: [],
      stateB: [],
      stateC: [],
      stateD: [],
      stateE: [],
      stateF: [],
      intervalId: 0,
      contador:0,
      message: '',
      title: '',
      msgA: '',
      msgB: '',
      msgC: '',
      msgD: '',
      msgE: '',
      msgF: '',
      popupActivo:false,
      showLastxAlertModal: false,
    }
  },
  methods: {
    getInfoTrucks(){
      const url_api = this.$store.state.url_api
      const messages = this.$store.state.messages
      this.msgA = messages.A
      this.msgB = messages.B
      this.msgC = messages.C
      this.msgD = messages.D
      this.msgE = messages.E
      this.msgF = messages.F

      axios.get(url_api + 'api/status', { params: {num_type:this.type} }).then((response) => {
        this.contador = this.contador +1
        this.stateA = response.data.stateA        
        this.stateB = response.data.stateB        
        this.stateC = response.data.stateC        
        this.stateD = response.data.stateD        
        this.stateE = response.data.stateE        
        this.stateF = response.data.stateF        
        this.newInfoBox = response.data.newInfoBox
      })
      .catch(() => {
        // console.error(error)
      })
    },
    activateUpdate(){
      const url_api = this.$store.state.url_api
      const response = axios.get(url_api + 'api/generalConfig').then((response) => {
        const timeInterval = response.data.time_interval * 1000
        this.intervalId = setInterval(() => {
          this.getInfoTrucks()
        }, timeInterval)
      })
    },
    activeTipe(){
      this.getInfoTrucks()
    }
  },
  mounted(){
    this.getInfoTrucks()
    this.activateUpdate()
  },
  destroyed: function () {
    clearInterval(this.intervalId)
  }
}
</script>
<style>
.btn_filter {
    float: none;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-left: 3px;
}
.div_btn_filter{
  text-align: right;
}
.ps_div_alert{
    text-align:center;
  }
.ps_alert_box_list{
    width: max-content;
    min-width: 300px;
    margin:0px auto;
  }
.vs-button:hover{
  color: white !important;
  background-color: white;
  border-color: white;
}
.ps_vs-row{
  justify-content: center;
}
.btn_act{
  margin-right: 3% !important;
  float: right !important;
  border-radius: 40px !important;
}
.btn_act.includeIconOnly {
  margin-right: 3% !important;
  width: 23px!important;
  height: 23px!important;
}
.btn_info{
  float: right !important;
  border-radius: 40px !important;
}
.btn_info.includeIconOnly {
  width: 23px!important;
  height: 23px!important;
}
.ps_vs-row .vs-icon {
  font-size: 1.5rem !important;
}
.pop_ps.con-vs-popup .vs-popup {
    width: 400px;
}
.pop_ps .vs-popup--header {
  background: #B87333;
}
.pop_ps .vs-popup {
  margin-top: 10em;
}
.pop_ps.con-vs-popup {
  align-items: start;
}
</style>